var XomInputDirective = /** @class */ (function () {
    function XomInputDirective() {
    }
    return XomInputDirective;
}());
export { XomInputDirective };
